import React, {Component} from 'react';
import {withRouter} from 'react-router';
import {
  Row,
  Col,
  Grid,
  Icon,
  Form,
  Panel,
  Button,
  PanelBody,
  FormGroup,
  InputGroup,
  PanelHeader,
  FormControl,
  PanelFooter,
  ControlLabel,
  PanelContainer,
} from '@sketchpixy/rubix';

import {getAdmin, getRoleGroups, updateAdminUser} from '../../api/api';

@withRouter
export default class AdminEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      adminUserId: null,
      adminUserEmail: null,
      adminUserName: null,
      roleGroupId: null,
      roleGroups: [],
    };
  }

  setCurrentUserInfo() {
    const adminUserId = this.props.params.adminUserId;

    getAdmin(adminUserId, (err, result) => {
      if (err) {

      } else {
        const admin = result.admin;
        const roleGroupIds = result.roleGroupIds;
        this.setState({
          adminUserId: admin.adminUserId,
          adminUserEmail: admin.adminUserEmail,
          adminUserName: admin.adminUserName,
          roleGroupId: roleGroupIds[0],
        });
      }
    });
  }

  componentDidMount() {
    this.setCurrentUserInfo();

    getRoleGroups((err, result) => {
      if (err) {
        alert('permission을 받아오는데 문제가 생겼습니다.');
      } else {
        this.setState({roleGroups: result});
      }
    });

    Messenger.options = {
      theme: 'flat',
    };
  }

  roleGroupChangeHandler = (event) => {
    const roleGroupId = event.target.value;
    this.setState({
      roleGroupId,
    });
  };

  back = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.router.goBack();
  };

  save = () => {
    const adminUserId = this.state.adminUserId;
    const adminUserName = this.state.adminUserName;
    const roleGroupId = this.state.roleGroupId;
    const roleGroupIds = [roleGroupId];

    updateAdminUser(adminUserId, adminUserName, roleGroupIds, (err, result) => {
      if (err) {
        //err
        console.log('error while saving : ', err);
        Messenger().post({
          type: 'error',
          message: 'Error while saving. please fill all fields and try again.',
          showCloseButton: true,
        });
      } else {
        this.setCurrentUserInfo();
        Messenger().post({
          type: 'success',
          message: 'saved successfully!',
          showCloseButton: true,
        });

        this.props.router.goBack();
      }
    });
  };

  adminUserNameChangeHandler = (e) => {
    this.setState({
      adminUserName: e.target.value,
    });
  };

  render() {
    return (
        <div>
          <PanelContainer controls={false} noOverflow>
            <Panel>
              <PanelHeader className='bg-pinkishred fg-white'>
                <Grid>
                  <Row>
                    <Col xs={12}>
                      <h3><Icon glyph='icon-fontello-edit' /> &nbsp; Edit user</h3>
                    </Col>
                  </Row>
                </Grid>
              </PanelHeader>
              <PanelBody>
                <Grid>
                  <Row>
                    <Col xs={12}>
                      <Form>
                        <FormGroup controlId='emailaddress'>
                          <ControlLabel>Email address</ControlLabel>
                          <InputGroup>
                            <InputGroup.Addon>
                              <Icon glyph='icon-fontello-mail' />
                            </InputGroup.Addon>
                            <FormControl
                                disabled
                                type='email'
                                placeholder='Email address'
                                value={this.state.adminUserEmail}
                            />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup controlId='username'>
                          <ControlLabel>User name</ControlLabel>
                          <InputGroup>
                            <InputGroup.Addon>
                              <Icon glyph='icon-fontello-user-1' />
                            </InputGroup.Addon>
                            <FormControl
                                type='text'
                                placeholder='User name'
                                value={this.state.adminUserName ? this.state.adminUserName : ''}
                                onChange={this.adminUserNameChangeHandler}
                            />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup controlId="dropdownselect">
                          <ControlLabel>Role Group</ControlLabel>
                          <FormControl
                              componentClass="select"
                              placeholder="select"
                              value={this.state.roleGroupId}
                              onChange={this.roleGroupChangeHandler}
                          >
                            {
                              this.state.roleGroups.map(roleGroup => (
                                  <option key={roleGroup.roleGroupId} value={roleGroup.roleGroupId}>
                                    {roleGroup.roleGroupName}
                                  </option>
                              ))
                            }
                          </FormControl>
                        </FormGroup>
                      </Form>
                    </Col>
                  </Row>
                </Grid>
              </PanelBody>
              <PanelFooter className='bg-pinkishred text-right'>
                <Grid>
                  <Row>
                    <Col xs={12}>
                      <br />
                      <div>
                        <Button bsStyle='brownishgray' onClick={this.back}>Cancel</Button>
                        &nbsp;
                        <Button bsStyle='brownishgray' onClick={this.save}>Save changes</Button>
                      </div>
                      <br />
                    </Col>
                  </Row>
                </Grid>
              </PanelFooter>
            </Panel>
          </PanelContainer>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/admin/AdminEdit.js